import { Lesson } from "@jelly/lesson";

import principle01 from "./layouts/principle-01/principle";
import task01 from "./layouts/task-01/task";
import task02 from "./layouts/task-02/task";
import task03 from "./layouts/task-03/task";

const lesson: Lesson = {
  id: "935b8d68-7683-481a-a309-8702b0c87af7",
  publicId: "7",
  name: "Prediction of reverberation time",
  difficulty: 1,
  contentTypes: { audio: false, interactive: true, video: false },
  body: [principle01, task01, task02, task03],
};

export default lesson;
